import { commonFunctions } from "../_utilities/commonFunctions";
import { configs } from "../config";
import { configes } from "../webData";

export const homeService = {
  getFaq,
  contact,
  carRegister,
  getBrandsByTenantId
};

function getFaq() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getFaqs/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function contact(data) {
  console.log(29, data);
  const extraHeaders = {
    "Content-Type": "application/json",
  };

  const requestOptions = commonFunctions.postRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/createWebsiteForm?tenantId=${configes.domainId}&carId=${data.carId}`,
    requestOptions
  ).then((responce) => responce.json());
}

function carRegister(data) {
  console.log(46, data);
  const extraHeaders = {
    "Content-Type": "application/json",
  };
  const requestOptions = commonFunctions.postRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/createCarRegisterFrom?tenantId=${configes.domainId}`,
    requestOptions
  ).then((responce) => responce.json());
}

function getBrandsByTenantId() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getBrands/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}